import { render, staticRenderFns } from "./YesNoAnswerBox.vue?vue&type=template&id=9b4b12ea&"
import script from "./YesNoAnswerBox.vue?vue&type=script&lang=js&"
export * from "./YesNoAnswerBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports